import { RegionShared } from "@1games-ru/region-shared";
import { Inventory, InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { setInventory } from "@/domains/inventory/slice";

export default function useGetEnvironment() {
  const dispatch = useAppDispatch();

  const getEnvironment = useCallback(async () => {
    try {
      const response = await RpcMpProvider.callServer<
        typeof RegionShared.Backend.Requests.GetEnvironmentOfDiscardedItemsRequest,
        typeof RegionShared.Backend.Responses.GetEnvironmentOfDiscardedItemsResponse
      >(RegionShared.Backend.Events.Inventory.GetEnvironmentOfDiscardedItems, {});

      if (response instanceof RpcMpProviderSuccessResponse) {
        dispatch(
          setInventory({
            ...response.data.inventory,
            items: response.data.inventory.items.map((item) => ({
              ...item,
              inventoryId: response.data.inventory.id,
            })) as unknown as InventoryItem[],
          } as unknown as Inventory),
        );
      } else {
        console.log(response.error);
      }
    } catch (e) {
      console.log(e);
    }
  }, [dispatch]);

  return {
    getEnvironment,
  };
}
